import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=afc11570"
import script from "./WhatsApp.vue?vue&type=script&lang=js"
export * from "./WhatsApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afc11570')) {
      api.createRecord('afc11570', component.options)
    } else {
      api.reload('afc11570', component.options)
    }
    module.hot.accept("./WhatsApp.vue?vue&type=template&id=afc11570", function () {
      api.rerender('afc11570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Tenants/ChannelIcons/WhatsApp.vue"
export default component.exports